import { useTranslation } from 'react-i18next';

const LEVEL_STYLES = {
    high: "bg-green-light text-green-normal",
    medium: "bg-yellow-light1 text-yellow-normal1",
    low: "bg-[rgb(255,236,199)] text-cal-dorange",
    critical: "bg-red-light text-red-normal",
};

const PriceLevelBadge = ({ level }) => {
    const { t } = useTranslation();
    const key = level && level.toLowerCase();
    const style = key && LEVEL_STYLES[key];
    if (!style) return null;

    return (
        <span className={`${style} inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-md capitalize`}>
            {key === "critical" &&
                <svg viewBox="0 0 16 16" fill="none" className="w-3 h-3 shrink-0">
                    <path d="M8 1.5 14.5 13.5H1.5L8 1.5Z" fill="currentColor" />
                    <path d="M8 6.2v3" stroke="white" strokeWidth="1.3" strokeLinecap="round" />
                    <circle cx="8" cy="11.1" r="0.8" fill="white" />
                </svg>
            }
            {t(key, level)}
        </span>
    );
};

export default PriceLevelBadge;
